module.exports = __webpack_public_path__ + "static/media/Nepali-Girl.c640096b.png";